import * as React from 'react';
import {Checklist} from "../../api/dtos/dtos";
import locales from "../../locales";
import ChecklistImagesForm from "../ChecklistImagesForm";
import {ChecklistFormMode} from "../dtos";
import ChecklistForm from "../ChecklistForm";


interface Props {
  style?: React.CSSProperties;
  rentalChecklist?: Checklist;
  returnalChecklist?: Checklist;
  mode: ChecklistFormMode;
}


class ChecklistDetailsSummary extends React.Component<Props, {}> {
  public render(): React.ReactNode {
    const {rentalChecklist, returnalChecklist, mode} = this.props;

    return (
      <>
        {rentalChecklist === undefined &&
            <div>{locales.rental_checklist_missing}</div>
        }

        <ChecklistForm
          rentalChecklist={rentalChecklist}
          returnalChecklist={returnalChecklist}
          editable={false}
          mode={mode}
        />

        <ChecklistImagesForm
          rentalChecklist={rentalChecklist}
          returnalChecklist={returnalChecklist}
          editable={false}
        />
      </>
    );
  }
}

export default ChecklistDetailsSummary;




// WEBPACK FOOTER //
// ./src/checklist/send/ChecklistDetailsSummary.tsx